const jobs = {
  bulk: {

    table: {
      direction: {
        distribute: 'Hacia la escuela',
        collect: 'De la escuela',
        both: 'Hacia la escuela & De la escuela',
      },

    },

    direction: {
      to: 'Hacia la escuela',
      from: 'De la escuela',
      both: 'Hacia la escuela & De la escuela',
    },

    form: {
      information: {
        details: {
          fields: {
            fromHour: 'La escuela comienza a las',
            toHour: 'La escuela termina a las',
            shift: 'Horas de la escuela',
            from: 'Casa',
            to: 'Escuela',
          },
        },
        locations: {
          header: 'Escuela',
          fields: {
            locations: 'Seleccionar Escuela'
          }
        },
      },
    },
  },

  forms: {
    information: {
      passengers: {
        header: 'Información personal',
        label: 'Seleccionar Alumnos'
      },
    }
  }
};

export default jobs;
